<template>

  <div>

  <div v-if="type == 'A'">  
    <modal-spinner v-if="modalSpinner.show==true" @close="setModalSpinner(false)" v-bind:props="modalSpinner"></modal-spinner>
   
    
    <printZebraModal :key="refreshZPL" v-bind:data='data'></printZebraModal> 
    <print-epl-modal :key="refreshEPL" v-bind:data='data'></print-epl-modal> 

  <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
  
  <div class="card bg-light">

    <div class="card-header ">
     
    <h4><strong> LISTA PRODOTTI DOCUMENTO </strong></h4>
    <h6>Numero prodotti  <span class="badge  badge-info">{{items.length}}</span>  </h6>
    <small id="Help" style="color:blueviolet" class="form-text  "><strong>doppio click modifica carico quantità e listino.</strong></small>  
   
    </div>
    
    <div class="card-body"> 
  
      <div class="row">
        
        <div v-if="pdf" class="col-sm-auto">
          <button @click="pdf=''" type="button" class="close"  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <iframe :src="pdf" width="400" height="400" style="border: none;margin-top:10px"></iframe>
        </div>  

    <div class="col">  

      <div  class="table-wrapper-scroll-y my-custom-scrollbar">
      <table class="table table-sm table-hover table-striped mb-0" id="table">
        
      <thead class="header">
        <tr>
          <th>#</th>
          <th></th>
          <th></th>
          <th>ID PRODOTTO</th>
        
          

          
          <th>STAGIONE</th>
          <th>CODICE ARTICOLO</th>
          <th>BRAND</th>
          <th>CATEGORIA</th>
          <th>COMPOSIZIONE</th>
          <th>REPARTO</th>
          <th class="text-right">Q.TA'</th>
          <th class="text-right">TOTALE</th>
          <th class="text-center">% SCONTO</th>
          
          
        </tr>
      </thead>
      <tbody>

      <tr @dblclick="editRow(product)" data-toggle="tooltip" title="doppio click modifica carico e listino varianti."   class="pointer" v-for="(product,index) in filteredProducts" :key="index">

        <td>{{index+1}}</td>
         <td>
          <div class="dropdown">
                    <button style="color:black;background-color: white;" class="btn btn-info btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                        <i class="fas fa-ellipsis-v mr-2" aria-hidden="true"></i>
                        OPZIONI
                    </button>
                    <div class="dropdown-menu ">

                    <a  class="dropdown-item" @click="stock(product)" href="#">
                    <i style="color:brown" class="fas fa-database mr-2" aria-hidden="true"></i>
                        Esistenza prodotto</a>
                    <a  class="dropdown-item" @click="tab(product)" href="#">
                    <i style="color:darkgreen" class="fas fa-columns mr-2" aria-hidden="true"></i>
                        Scheda prodotto </a>
                    
                    <div class="dropdown-divider"></div>   
                    <a   class="dropdown-item" @click="printModal(product)" href="#">
                    <i   style="color:blueviolet" class="fas fa-print mr-2" aria-hidden="true"></i>
                        Stampa etichette 
                        <span v-if="spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
                      </a>
                    

                        
                    </div>
                    </div>
         </td>
         <td> <span :class="{dotRed:product.colorCount > 0}"></span></td>
        <td>{{product.productId}}</td>

       
        
        <td>{{product.seasonYear}}</td> 
        <td>{{product.sku}}</td>
        <td>{{product.brand.toUpperCase()}}</td>
        <td >{{product.category}}</td>
        <td >{{product.material}}</td>
        <td >{{product.department}}</td>
        <td class="text-right">{{product.qtyItem}}</td>
        <td class="text-right">{{product.totalItem.toLocaleString('de-DE',{ style: 'currency', currency: 'EUR' })}}</td>
        <td class="text-center">{{product.discount_list}}</td>
        

      </tr>
      </tbody>
      <tfoot>
           <tr>
         
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>

          <th class="text-right">{{totalQty}}</th>
          <th class="text-right">{{totalVal.toLocaleString('de-DE',{ style: 'currency', currency: 'EUR' })}}</th>
          <th></th>
        
        </tr>
      </tfoot>  
    </table>
  </div>
  <label for="cerca"><strong>Filtra</strong></label>
         <input class="form-control" type="text" name="query" v-model="filterKey">

  
  <!-- card BODY -->
  </div>

  </div>
  </div>
  


    <!-- BODY CARD -->
  </div>
    
   
    <button :disabled="filteredProducts.length==0" @click="printDocument()"  class="btn btn-outline-info mt-2 ml-2">
      <i  class="fas fa-print mr-2" aria-hidden="true"></i>
      STAMPA DOCUMENTO
      <span v-if="bt_spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </button>

    
 
  </div>

  


  </div>
</template>

<script>


import { mapGetters } from 'vuex';
import api             from '@/api'
//import axios           from 'axios'
//import spinner        from '@/components/common/Spinner.vue';
import alertBox        from '@/components/common/AlertBox.vue'
import modalSpinner    from '@/components/common/ModalSpinner.vue'
import printZebraModal from '@/components/common/PrintZebraModal.vue';
import printEplModal   from '@/components/common/PrintJSPMModal.vue';
import jsPDF           from 'jspdf';
//import {eanCD,createEAN13}         from '@/functions';   


  export default {
     props : ['documentId'],
     components: {alertBox,modalSpinner,printZebraModal,printEplModal},
    data () {
      return {

        type          : 'A',
        productId     : 0,
        
        items         : [],
        
        filterKey     : '',
        spinner       : false,
        pdf           : '',
       
        bt_spinner    : false,        
        item          : null,
        msg           : {title : '',body:'',type :0},
        modalSpinner  : {spinner:false,show:false},
        refreshEPL    : 0,
        refreshZPL    : 100,
        data          : []
        
      }
    },
    watch :
    {

    },
    
  
    computed: {
      ...mapGetters(['company']),
      filteredProducts : function () 
      {
        
        
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) 
        {
            items = items.filter(function (row) 
            {
                return Object.keys(row).some(function (key) {
                return String(row[key]).toLowerCase().indexOf(filterKey) > -1
              })
            })
        }
        return items

     },
     
       


     
     
      totalQty ()  
      {
        var totale = 0
          this.items.forEach(item => {
             totale = totale + Number(item.qtyItem)
          
        });
       
        return totale
      },
      totalVal ()
      {
        var totale = 0
        
          this.items.forEach(item => {
            totale = totale + Number(item.totalItem)
          
          });
        
        return totale
      },
      
      
    },
    mounted()
    { 
     
      var obj = {documentId : this.documentId}
      this.getData(obj)  
    },
    created () 
    {
      
      //this.row = localStorage.getItem('LastRow');
      //console.log(this.row)

    },
    beforeDestroy()
    {
      
      //console.log('Row',this.row)

    },
    methods: 
    {
      fmtCurrency(value)
      { 
      if(!isNaN(value))
      {
      return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: 2 ,maximumFractionDigits: 2});
      }
      },
      async printModal(item)
      {
        
        let lang = this.company.printer_type
        this.spinner = true  
        
        this.data = await this.getDataToPrint(item)
        this.spinner = false
        
        if(lang=='EPL')
        {
          this.refreshEPL++
          this.$nextTick(() => {
            $('#printEPLModal').modal({keyboard: false,backdrop:'static','show':true});
            })
        }
        else
        {
          this.refreshZPL++
          this.$nextTick(() => {
           $('#printZebraModal').modal({keyboard: false,backdrop:'static','show':true});
            
        })  
        }
        
      },

      test(productId)
      {
        alert(createEAN13(productId,99))
      },
      setModalSpinner(show)
      {
        

        this.modalSpinner.show = show
        
      },
      tab(product)
      {
        this.$emit('option',product,'tab')
        
      },
      stock(product)
      {
        this.$emit('option',product,'stock')
         
        
      },
      editRow(item)
      {
        
        this.$emit('editRow',item)
      },
   
      async printDocument()
      {
    
      const doc = new jsPDF()

      this.spinner2 = true  
      var page = 1
      
      let items = []
      
      this.filteredProducts.forEach(item =>{
        items.push(item)
      })
      
      
      items.sort((a, b)=>{
      let x = a.department.toLowerCase();
      let y = b.department.toLowerCase();
        if (x < y) {return -1;}
        if (x > y) {return 1;}
        return 0;
      });
      
      

      let document = await this.getDocument()
        if(document.length == 0) 
        {
          return
        }
       let title = {type:document[0].description,data:document[0].date,number : document[0].number,supplier:document[0].supplier }
        
      var pages = parseInt(items.length / 50) == items.length / 50 ? parseInt(items.length / 50) : parseInt(items.length / 50) + 1
      
      var row_index = 1
      var page_index = 1
      var init_row = 31
      var row = init_row
      var row_header = row -5

      //var col = 5
      var col1 = 10
      var col2 = 50
      var col3 = 70
      var col4 = 100
      //var col5 = 121
      //var col6 = 150
      var col7 = 120
      var col8 = 180
      var col9 = 205
      //var total = 0
      //var row_count = 0
      //var doc = new jsPDF()

      var header = function(title)
      {
        var d = new Date();
        var n = d.toLocaleString();
        doc.setFontSize(14)
        
        doc.setFont("helvetica",'bold')
        doc.text(title.supplier + ' ' + title.type + ' ' + title.number + ' ' + title.data,  105, 10, null, null, "center");

        doc.setTextColor(0, 0, 255);
        //doc.text(customer,  105, 15, null, null, "center");
        doc.setTextColor(0, 0, 0);
        
       // doc.text('CASSA ' + description3,  105, 20, null, null, "center");
        
        
      
        doc.setFontSize(10)
      
        doc.text('ARTICOLO', col1,row_header);
        doc.text('BRAND', col2, row_header);
        doc.text('CATEGORIA', col3, row_header);
        doc.text('REPARTO', col4, row_header);
       // doc.text('MATERIALE', col5, row_header);

      //  doc.text('DIMENSIONE', col6, row_header,null,null,'right');
        doc.text('STAGIONE', col7, row_header);
        doc.text('Q.tà', col8, row_header,null,null,'right');
        doc.text('TOTALE', col9, row_header,null,null,'right');
        doc.setFont("helvetica",'normal')
        

      }
      var footer = function()
      {
        doc.setFontSize(8)
        doc.text('pag. ' + page.toString() + ' / ' + pages.toString(),  105, 290, null, null, "center");
       
      }
      header(title)
      footer()


      items.forEach(item=>{
               
        doc.setFontSize(8)
       
       
       
        doc.setFont("helvetica",'normal')
        
        doc.text(item.sku.toString().substr(0,50), col1, row);
        doc.text(item.brand.toString().substr(0,10), col2, row);  
        doc.text(item.category.toString().substr(0,20), col3, row);
       
        
        doc.text(item.department.toString(), col4, row);
        doc.text(item.seasonYear.toString(), col7, row);
        doc.text(item.qtyItem.toString(), col8, row,null,null,'right');
        doc.text(this.fmtCurrency(item.totalItem.toString()), col9, row,null,null,'right');
        
        //row_count++

         
        

        
        if(page_index == 50 && row_index < items.length)
        {
          page++  
          doc.addPage("a4");
          header(title)
          footer()
          row = init_row
          row_index++
          page_index = 1
        }
        else
        {
          row = row + 5
          row_index++
          page_index++
        }
        
      })
      doc.setFontSize(10)
      
      doc.rect(5, 282, 203, 4)
      
      
      doc.setFont("helvetica",'bold')
      doc.text('TOTALE DOCUMENTO' ,  10, 285, null, null);  
      doc.text(this.totalQty.toString() ,  180, 285, null, null, "right");
      doc.text(this.fmtCurrency(this.totalVal) ,  205, 285, null, null, "right");
      
      let fileName = 'Document_' + Date.now().toString()
      window.open(doc.output('bloburl', { filename: fileName }), '_blank');
      this.spinner2 = false

    },

  
      async getDocument()
      {
        this.msg.title = ''
        let document = {"documentId" : this.documentId}
        let sp       = {'sp' : 'spDocumentHeader'}
        let json     = Object.assign(document, sp);
        
        return new Promise( async (resolve) =>  {

        await api.post(json).then(res => {
          
          if(res.status==200)
            {
                
                resolve(res.data.recordsets[0])

            }
           else if(res.status==500)
           {
                let arr = []
                resolve(arr)
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res.data
                this.msg.type = 1                           
                

                
                    
           } 
           else
            {
                let arr = []
                resolve(arr)
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res
                this.msg.type = 1   

              
                 
            } 
          

          }).catch(err => {
              
              let arr = []
              resolve(arr)
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                        

              
          }).finally(() => {
          this.spinner = false
        });

        })

      },

      getDataToPrint(item) 
      {
      
        let data     = {'productId' : item.productId,'movementId':item.stockMovementId}
        let sp       = {'sp':'spMovementProductBarcodes'}        
        
        var json  = Object.assign(data, sp)
        return new  Promise( async (resolve, reject)  =>  {
        
        await api.post(json).then(res => {
          
          if(res.status==200)
            {
               resolve(res.data.recordsets[0])   
            }
           else if(res.status == 500)
           {
                
                
                console.log(res.data)                    
           } 
           else
            { 
                
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          //this.spinner = false
        });          
        
        })

      }, 
    
      async getData(item)
      {
        

        //this.spinner = true
        this.modalSpinner.show    = true
        this.modalSpinner.spinner = true
        this.modalSpinner.title   = 'Caricamento prodotti in corso ...'

        


        var sp    = {'sp' : 'spDocumentProducts'}
        var json  = Object.assign(item, sp);
        await api.post(json).then(res => {
          
          if(res.status==200)
            {
                this.items = res.data.recordsets[0]
                this.modalSpinner.show = false 
                
                //console.log(this.items)

                let products = []
                this.items.forEach(item=>{
                  products.push({'productId':item.productId})
                })
                this.$emit('ProductsDoc',products)
              
            }
           else if(res.status==500)
           {
                this.modalSpinner.spinner = false            
                this.modalSpinner.msg = res.data
                console.log(res.data)

                
                    
           } 
           else
            {
                console.log('Network Error.')     
                this.modalSpinner.spinner = false            
                this.modalSpinner.msg = res             
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              this.modalSpinner.spinner = false            
                this.modalSpinner.msg = err.message
          }).finally(() => {
          //this.spinner = false
        });


      },
     
      
     
     
      deleteProduct (id) {
        console.log(id)
      
      }
      

    }
  }
</script>
<style scoped>
  

  .pointer:hover
{
  background-color : blue;
  color            : white;
  cursor           : pointer;
}
 
  .my-custom-scrollbar {
    
    height    : 350px;
    overflow  : auto;
    position  : relative;
    
    }

  .table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : rgb(119, 38, 200);
    color        : whitesmoke;
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }  

 
.table tfoot  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 20px;
    background   : whitesmoke;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

  .table-wrapper-scroll-y {
    display   : block;
  }
  
  p,h4 {
  font-family : 'Roboto Condensed';
  font-size   : 20px;
   }


.dotGreen
{
  height: 15px;
  width: 15px;
  
  border-radius: 50%;
  display: inline-block;
  background-color: green;
}
.dotRed
{
  height: 10px;
  width: 10px;
  
  border-radius: 50%;
  display: inline-block;
  background-color: red;
}
.fa-database
{
  color : #736AFF;
  
}


.fa-columns
{
  color : chocolate;
}
.fa-database:hover{
  color : white
}
.fa-columns:hover{
  color : white;
}
</style>
